import { Button, Checkbox, Paper } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

export const StyledCheckbox = styled((props) => <Checkbox {...props} />)`
  .checkbox {
    cursor: default;
    margin-top: 17px;
    margin-left: 20px;
  }

  &&& {
    span.MuiButtonBase-root {
      svg {
        border: ${({ theme }) => theme.checkboxBorder};
        border-radius: 4px;

        rect {
          fill: ${({ theme }) => theme.checkboxFill};
        }
      }
      &.Mui-disabled {
        opacity: 1;
      }
    }
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 15px 0;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  padding: 0px;
  margin-top: 22px;
  width: 117px;
  min-width: 60px;
`;

export const StyledPaper = styled((props) => <Paper {...props} />)`
  && {
    background-color: ${({ theme }) => theme.homeLoaderBackground};
    border: none;
  }
`;

export const MasterGameHeader = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.filterBar};
  color: ${({ theme }) => theme.filterBarColor};
`;

export const TableMenu = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  &&& .MuiInputBase-root {
    background-color: ${({ theme }) => theme.inputBackgroundColor};

    .MuiInputBase-input {
      color: ${({ theme }) => theme.inputTextColor};

      &::placeholder {
        color: ${({ theme }) => theme.inputPlaceholderColor};
      }
    }
  }

  &&& .MuiFormControlLabel-root {
    .MuiTypography-root {
      color: ${({ theme }) => theme.switchTextColor};
    }

    .MuiSwitch-thumb {
      background-color: ${({ theme }) => theme.switchCircleBackgroundColor};
    }

    .MuiSwitch-track {
      background-color: ${({ theme }) => theme.switchTrackBackground};
    }

    .Mui-checked + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.switchTrackCheckedBackground};
    }
  }
`;

export const NoGamesWithFilters = styled.div`
  height: 335px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  cursor: pointer;

  svg path {
    fill: ${({ theme }) => theme.watchArrowFill};
  }
`;

export const CellContent = styled.p<{ maxWidth?: string }>`
  max-width: ${(props) => props.maxWidth || '150px'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
